export const Type_Hour = 1;